import React, { Component } from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
 
const icon1 = "https://winpeforum.com/assets/elements/bhavna_thakur.jpg";
 
const icon2 = "https://winpeforum.com/assets/elements/Ganesh_Mani.jfif";
const icon3 = "https://winpeforum.com/assets/elements/Sakshi_Chopra.jpg  ";
const icon4 = "https://winpeforum.com/assets/elements/Naik_Sandeep.jpg";
const icon5 = "https://winpeforum.com/assets/elements/sridhar-sankararaman-it.png";
const icon6 = "https://winpeforum.com/assets/elements/Sawheny_Viraj.jpg";

const icon7 = "https://winpeforum.com/assets/elements/Session1_Shikha_Pareek.jpg";
const icon8 = "https://winpeforum.com/assets/elements/Pranay-Aggarwal.jpg";
const icon9 = "https://winpeforum.com/assets/elements/shriya_bahul.jpeg";
const icon16 = "https://winpeforum.com/assets/elements/Kanakvi.jpg"; 

const icon10 = "https://winpeforum.com/assets/elements/Fernnades-Priyanka_Picture.jfif";
const icon11 = "https://winpeforum.com/assets/elements/Isha-Dalal.JPG";
const icon12 = "https://winpeforum.com/assets/elements/Anshul-Lodha.jpg";
const icon13 = "https://winpeforum.com/assets/elements/Session2_Vishal.jfif";


const icon14 = "https://winpeforum.com/assets/elements/Harjot-Dhaliwal.jpg";
const icon15 = "https://winpeforum.com/assets/elements/VarunTalukdar.jpg";

let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class CareerBootcamp extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isShow: false,
  //     activeItem: {},
  //   };
  // }

  // togglePopUp = (item) => {
  //   this.setState({
  //     isShow: !this.state.isShow,
  //     activeItem: item || {},
  //   });
  // };
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    this.Speaker = [
      {
        imgUrl: icon1,
        desc: `<div>Bhavna Thakur joined Everstone as the Head of Capital Markets in 2015. She has
        over 20 years of corporate finance, investment banking, M&amp;A and capital markets
        experience and has worked with banks, financial services providers and legal firms
        worldwide. These include investment banking at Citigroup Global Markets and
        Morgan Stanley in Mumbai and Hong Kong respectively and capital markets and
        M&amp;A law at Davis Polk &amp; Wardwell in New York and London and Paul Weiss in New
        York. Bhavna holds a Bachelor of Laws from the National Law School of India
        University, Bangalore and a Master of Laws from Columbia University, New York.
		</div>`,
        name: "Bhavna Thakur",
        post: `<div>Managing Director, <br/>Capital Markets <br /> Everstone </div>`,
      },
      {
        imgUrl: icon2,
        desc: `<div>Ganesh Mani is a Managing Director in Blackstone’s Private Equity Group. Since joining Blackstone in
        2011, Mr. Mani has been involved in Blackstone’s investments in Sona Comstar, Aadhar Housing
        Finance, Trans Maldivian Airways, IBS Software, International Tractors Limited, CMS Info Systems,
        Multi Commodity Exchange of India Ltd., and Jagran Prakashan. Mr. Mani is involved in the
        evaluation of investment opportunities in the pharma and healthcare, financial services, automotive,
        and specialty chemicals sectors in South Asia. Mr. Mani currently serves on the Board of Directors of
        Sona Comstar.
        <br><br>
        Before joining Blackstone, Mr. Mani was an Associate at the Boston Consulting Group. Mr. Mani
        received a B.Tech. in Mechanical Engineering from the Indian Institute of Technology Bombay.
				</div>`,
        name: "Ganesh Mani",
        post: `<div>Managing Director<br /> Blackstone</div>`,
      },
      {
        imgUrl: icon3,
        desc: `<div>Sakshi focuses on growth stage companies and has advised on investments across a range of Consumer, D2C and Fintech companies including Five-Star Business Finance, Indigo Paints, Wakefit, Faces, GoColors, Healthkart, Hector Beverages and B9 Beverages. 
				<br />
				<br />
				Sakshi began her career with Deutsche Bank, where she worked in the executive office of the Global Head of Private and Business Clients (Board Member of the Bank) in Germany, and later in Global Transaction Banking in India, before joining Sequoia Capital India in 2010. She holds an MBA from the Asian Institute of Management and a bachelor’s degree from Sydenham College of Commerce.
		</div>`,
        name: "Sakshi Chopra",
        post: `<div>Principal <br /> Sequoia India</div>`,
      },
      {
        imgUrl: icon4,
        desc: `<div>Sandeep Naik is a Managing Director at General Atlantic and serves on the firms Executive
        Committee. He head’s the operations for India and Asia Pacific. Mr. Naik manages and oversees
        all of GA’s investments in these regions, which include Byju’s, Jio, Reliance Retail,
        Ruangguru, PT MAP Boga Adiperkasa (MBA), Krishna Institute of Medical Sciences Limited,
        BillDesk, House of Anita Dongre, IIFL Wealth Management and KFin Technologies Private
        Limited.
        <br /><br />
        Previously, Mr. Naik served as a partner and co‐head of the India office for Apax Partners, leading
        their investments in healthcare, financial & business services and retail & consumer sectors. Prior
        to joining Apax, he was a Global Marketing Manager at Medtronic Inc, a scientist at Mayo Clinic
        and a Consultant with McKinsey. He is also the co‐founder of a medical device start up firm,
        InfraScan Inc., which is focused on detecting bleeding inside the brain using a handheld device.
        <br /><br />
        Mr. Naik is an avid community worker. Among other philanthropic endeavors, he co‐founded
        ToolBox India, an organization that brings professionals and non‐profits together to improve
        productivity and efficiency within the social sector.
        <br /><br />
        Mr. Naik holds a BTech in Instrumentation Engineering from the University of Mumbai, an M.S.
        in Biomedical Engineering from the Medical College of
        Virginia and an M.B.A. in Finance from The Wharton School of Business, University of
        Pennsylvania. Mr. Naik was selected as a Young Global Leader by the World Economic Forum
        and served on the Global Agenda Council of ‘New Order of Economic Thinking’. Mr. Naik is also
        a member on the Wharton Asia Board.
		</div>`,
        name: "Sandeep Naik",
        post: `<div>Managing Director <br /> General Atlantic</div>`,
      },
      {
        imgUrl: icon5,
        desc: `<div>I have two decades of experience in financial services (including 15 years in private equity). I have
        been with <a href="https://multiplesequity.com/" target="
        _BLANK" >Multiples</a> (US 1.5 bn PE fund) since its inception in 2009. Prior
        to this, I was with SUN Capital in London and E&Y in Mumbai.</br>
        My current role is to lead investments in digital, B2C and consumer technology sectors. Previously, I
        led investments across healthcare, pharma and manufacturing sectors. I have actively contributed to
        the creation of and institutionalisation of investment and people evaluation frameworks for Multiples.
        During my investing career and as an active Board member, I have been able to influence business
        strategy and people decisions. I think of my ability to influence as a key strength and I use it to bring
        about positive change. I enjoy brainstorming ideas with Founders and derive immense satisfaction
        when they derive value from these interactions as well.</br></br>
        I am a Chartered Accountant by training and received my MBA from Indian School of Business (Dean’s
        List). Recognised among ‘40 under 40’ by AIWMI in 2018.</br></br>
        My professional success has been greatly shaped by my mother, who always made available the time
        and resources for the right things in life and taught me the value of resource allocation. When I am
        not working, I enjoy spending time with my family, particularly with my young son and daughter.
		</div>`,
        name: "Sridhar Sankararaman",
        post: `<div>Managing Director <br /> Multiples</div>`,
      },
      {
        imgUrl: icon6,
        desc: `<div>Viraj Sawhney, based in Mumbai, joined Warburg Pincus in 2005 and evaluates investment opportunities across TMT and Business Services. Sectors covered by him include logistics, telecom, technology services and BPO. Prior to joining Warburg Pincus, Mr. Sawhney was an Engagement Manager with McKinsey & Company where he spent five years serving clients across India, S.E. Asia and Australia. He is a Director of Encora Holdings Limited, Vivtera Holdings, Princeton Digital Group, Ecom Express, Rivigo and Stellar Value Chain Solutions. Mr. Sawhney holds a B.A. degree in Mathematics from St. Stephens College (Delhi University) and a post-graduate diploma in management from IIM Ahmedabad.
		</div>`,
        name: "Viraj Sawhney",
        post: `<div>Managing Director, Mumbai <br /> Warburg Pincus</div>`,
      },
    ];

    this.Speaker1 = [
      {
        imgUrl: icon16,
        desc: `<div>Kanakvi joined Sequoia India in 2021 as an investment analyst in the growth
        team, where she is exploring her passion for technology and start-ups across
        sectors.<br/>
        Prior to this, she was a business analyst at McKinsey & Company for a year and
        half. During this time, she worked primarily on strategy studies and due
        diligences in Financial Services and CPG.<br/>
        She holds a B.Tech in Electronics and Electrical Communication Engineering
        with a Minor in Computer Science from IIT Kharagpur. Kanakvi co-founded the
        Lean In circle in her college campus and continues to provide mentorship to
        and collaborate with other women on advancement in their professional as
        well as personal journeys. 
		</div>`,
        name: "Kanakvi Aggarwal",
        post: `<div>Investment Analyst<br/>Sequoia India</div>`,
      },
      {
        imgUrl: icon8,
        desc: `<div>Pranay Agarwal joined Warburg Pincus in 2020 and is an Associate in the Investments Group. He spends majority of his time in Technology, Real Estate and Industrial sectors at Warburg. Prior to joining Warburg, Pranay was with Bain & Company for ~2 years where he worked on 10-15 commercial diligences across different industries. He has also worked with a non-profit ‘Goonj’ for brief period and was helping them scale their urban operations. He holds a B.Tech in Chemical Engineering and Minor in Management from Indian Institute of Technology, Bombay. Prior to that, he did his education from Pune and has interests in football and dancing
		</div>`,
        name: "Pranay Agarwal",
        post: `<div>Associate<br/>Warburg Pincus </div>`,
      },
      {
        imgUrl: icon7,
        desc: `<div>Shikha is an Investment Professional with the Credit and Special Situations team at KKR India. Previously, she was part of the India investment banking team at Bank of America and UBS respectively and has worked across sectors including consumer retail, health-care and technology. She is a Chartered Accountant by training`,
        name: "Shikha Pareek",
        post: `<div>Investment Professional  <br /> KKR & Co. India</div>`,
      },
      {
        imgUrl: icon9,
        desc: `<div>With a background in development economics and finance, Shriya has always been passionate about working in the impact space. Her current work entails focusing on investments that promote access to finance, clean and green energy and women owned businesses. She strongly believes that investing in women can have a multiplier effect on the economy by not only encouraging other younger women but also enabling investors to generate additional revenue streams. At Winpe she hopes to collaborate closely with Women Entrepreneurs to help them scale businesses and facilitate them in the fundraising processes.
		</div>`,
        name: "Shriya Bahul",
        post: `<div>Investment Analyst <br />   IFC</div>`,
      },
    
       
    ];
    this.Speaker2 = [
     
      {
        imgUrl: icon12,
        desc: `<div>Anshul joined the group in 2012 from Lazard where he worked as an investment banker focusing on M&A and private equity advisory practice across multiple sectors. Anshul started his career in the alternative investment division of ICICI (India’s largest private sector bank) where he was part of private equity fund of fund’s practice. He holds MBA from top Tier B School in India specializing in Finance and is a certified FRM (GARP).<br/><br/> Anshul currently leads the BFSI, Sales & Marketing, Legal and Property & Construction practices for PageGroup based out of the Mumbai office and has extensive experience recruiting for C-suite level positions in all of the above sectors.
		</div>`,
        name: "Anshul Lodha",
        post: `<div>Regional Director<br/>Michael Page</div>`,
      },
      {
        imgUrl: icon11,
        desc: `<div>I have spent six years in the investment team at Multiples, primarily in the
        Consumer sector encompassing retail, food products, FMCG, consumer tech
        and others. Apart from deal evaluation, I’ve played a key role in developing the
        firm’s top-down thesis in these sectors and worked closely with portfolio
        companies to create value.<br/>
        My non-traditional background as a corporate law journalist with CNBC-TV18
        enabled me to develop the art of building and nurturing relationships as well as
        to identify impactful stories by asking the right questions. I enjoy leveraging
        these skills in my role as an investment professional, driven by a curiosity for
        businesses and what drives their success.<br/>
        My education has presented me with an opportunity to be exposed to different
        cultures. I hold a BA degree in English at Haverford College in PA, USA during
        which time I spent a year at Oxford University in England. I received my MBA
        from Columbia Business School in NYC.<br/>
        I’m an avid foodie and cook, and a fitness enthusiast. When not working, I enjoy
        experimenting with new recipe and unwinding with my young son, who is my
        greatest inspiration. </div>`,
        name: "Isha Dalal",
        post: `<div>Vice President <br />Multiples</div>`,
      },
      {
        imgUrl: icon10,
        desc: `<div>Priyanka Fernandes is the HR Business Partner in Blackstone’s Human Resources Group. Since joining Blackstone in 2017, Ms. Fernandes has been involved in recruiting, developing and retaining talent for the India office.
        <br/> <br/>
        Before joining Blackstone, Ms. Fernandes was a part of the Human Resources team at Everstone Capital and Morgan Stanley. Ms. Fernandes received a B.Engg. in Computer Engineering from the University of Mumbai and a MSc in International Human Resources from the Manchester Metropolitan University.
		</div>`,
        name: "Priyanka Fernandes",
        post: `<div>HR Business Partner <br />   Blackstone</div>`,
      },
      {
        imgUrl: icon13,
        desc: `<div>Vishal is currently the Executive Director with the Everstone Group.
<br/>
        Previously worked as an Associate at Warburg Pincus since May 2012 to Apr 2017. Closed deals in auto ancillary space in April 2013, Real Estate deal in July 2015 and Oct 2015. Have worked extensively on Financial Services and Infrastructure space. Analyst with Asia Investment Banking team at J.P. Morgan covering Industrials & Transportation sector from 2010 to 2012 (Rated Best Analyst among my peer group). Gold Medalist at IIM Indore securing 1st Rank in both the years in a batch of 240, 2008-10. Awarded Best All-rounder at IIM Indore for outstanding performance in academic and extracurricular activities. Runners-up in the National round of the CFA Global Investment Challenge - an event organized by CFA Institute.
		</div>`,
        name: "Vishal Goenka",
        post: `<div>Executive Director <br />   Everstone Group </div>`,
      },
       
    ];

    this.Speaker3 = [
     
      {
        imgUrl: icon14,
        desc: `<div>Harjot focuses on investments in technology and telecom sectors and has participated in key deals including Fractal Analytics and Azentio Software. Prior to joining Apax Partners, Harjot was a Vice President at Warburg Pincus, where she focused on investment opportunities in TMT and business services sectors. Before pursuing her MBA, Harjot was a part of the investment team at TA Associates and the investment banking practice at Rothschild India. Harjot holds an MBA from Harvard Business School and a bachelor’s degree in Chemical Engineering from Indian Institute of Technology Delhi.
		</div>`,
        name: "Harjot Dhaliwal",
        post: `<div>Principal<br/>Apax Partners</div>`,
      },
      {
        imgUrl: icon15,
        desc: `<div>Varun Talukdar is a Vice President at General Atlantic and focuses on the firm’s investments in the India & Asia-Pacific region. Before joining General Atlantic in 2013, Varun was an Investment Professional at Premji Invest where he concentrated on investments in the retail & consumer and education sectors. Prior to that, Varun worked with the Lehman Brothers Bankruptcy Estate in New York to manage and unwind its Indian private and public equity assets. He has also worked at Bayside Capital, the Miami-based credit investment arm of H.I.G. Capital, and in the Industrials Investment Banking division of Bank of America in New York. </div>`,
        name: "Varun Talukdar",
        post: `<div>Vice President <br />General Atlantic</div>`,
      },
      
       
    ];
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
      <Meta
      title="Winpe Ignite | Career Bootcamp      "
      image={"https://winpeforum.com/assets/elements/WinPE_Home_Page_link_image1.jpg"}
      description="A series of three action-packed sessions that prepared participants for their break into investing. From getting your CV right to prepping for the interview and acing it.     "
      location={location}
    />
     
     <div className="section__content" style={defaultStyle}>
     <div className="toastshine_wrapper">
     
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div> 
     
         
        <h1 className="ignite-ask-me-anything__heading">Winpe Ignite</h1>
        <h2 className="ignite-ask-me-anything__heading">
          <em>Career Bootcamp</em>
        </h2>

        <hr className="ignite-ask-me-anything__hr"></hr>

        <div className="ignite-ask-me-anything__date">
          <span>29 MAY, 5 JUNE, 12 JUNE 2021, 3-4pm IST, Online</span>
        </div>

        <p className="ignite-ask-me-anything__intro">
        A series of three action-packed sessions that prepared participants for their break into investing. From getting their CV right to prepping for the interview and acing it.
        </p>
        <p className="ignite-ask-me-anything__intro">
        <strong>SESSION 1:</strong> The Technical Q&A with recent hires into investing discussed how to track vacancies and apply, how to prepare, commonly asked questions; and some tips and tricks. At the end of the session, <strong>20 attendees got to share their CVs with a panel of industry recruiters and received direct feedback on how to strengthen the same.</strong>
        </p>
        <p className="ignite-ask-me-anything__intro">
        <strong>SESSION 2:</strong> A CV Review session with a panel of industry recruiters discussed how to make a CV stand out, what do recruiters look for, best practices, tips and some common mistakes. <a href="#IndustryLeaders"><strong>5 attendees got the opportunity to speak 1:1 with an industry leader.</strong></a>
        </p>
        <p className="ignite-ask-me-anything__intro">
        <strong>SESSION 3:</strong> Acing the interview saw 2 amazing participants go through a mock interview with senior industry recruiters. The recruiters shared their tips on how to interview, what recruiters look for and how they evaluate candidates. 
        </p>
        <p className="ignite-ask-me-anything__intro">
        <br/>
        </p>
        <br />
        <h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '30px'}}>Takeaways From the Sessions</h2>
        <hr className="ignite-ask-me-anything__hr"></hr>
 
<a href="https://winpeforum.com/assets/elements/Panel-Discussion-With-Recent-Hires-On-Getting-That-Investing-Job.pdf" target="_blank" style={{textDecoration: 'underline'}}> <h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '20px'}}>Panel Discussion With Recent Hires On Getting That Investing Job
</h2></a>
         
 <a href="https://winpeforum.com/assets/elements/Recruiters-Insights-On-How-To-Make-A-Good-CV.pdf" target="_blank" style={{textDecoration: 'underline'}}>
 
<h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '20px'}}>Recruiters’ Insights On How To Make A Good CV
</h2></a>
      
<a href="https://winpeforum.com/assets/elements/How-to-Ace-the-Interview.pdf" target="_blank" style={{textDecoration: 'underline'}}>
<h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '20px'}}>How to Ace the Interview</h2></a> <br/>
<h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '30px'}}>Testimonials</h2>  <hr className="ignite-ask-me-anything__hr"></hr>


 
		 
          <div className="container">
			  	<div className="card col-md-12 mt-2"> 
			      	<div id="carouselExampleControls" className="carousel slide" data-ride="carousel" data-interval="100000">
			        	<div className="w-100 carousel-inner " role="listbox">
			          		<div className="carousel-item active">
			            		<div className="bg"></div>
			            		<div className="row">
				            		<div className="col-md-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								               
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em> “Incredibly insightful, many thanks!”</em></small>
								                  <h2 className="ignite-ask-me-anything__intro">-Shivani Kabra </h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
				            	 
			            		</div>
			          		</div>
                    <div className="carousel-item  ">
			            		<div className="bg"></div>
			            		<div className="row">
				            	 
				            		<div className="col-md-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								                  <small className="ignite-ask-me-anything__intro"><em>“thanks a lot. amazing bootcamp”</em></small>
								                 
								                  <h2 className="ignite-ask-me-anything__intro">-Shikha Gupta</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
			          		<div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								               
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“This was a very insightful, valuable session - appreciate the panelists for taking out their time - and also for my CV review :) And big thanks to Winpe for hosting this :)"</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">-Dhwani Nanavati</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
				             
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            	 
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>"thank you winPe for the lovely session"</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">-Harini Shrinivasan</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
			          		<div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								               
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“This was an amazing session! Hope we see more of impact investing sessions soon :)”</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Shivangi Saxena</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
				            	 
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				             
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>"Very authentic & great session!"</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Vidisha Gupta</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								               
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>"Thank you for this incredibly insightful session!"</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Moksha Miss</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
				            	 
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            	 
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“Thanks, very helpful!”</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Anisha Belur</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“Thank you for the session!”</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Shubhranka Mondal</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								               
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“Thank you Winpe team for the session!”</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Heena Kedia</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
				            	 
			            		</div>
			          		</div>
                    <div className="carousel-item">
			            		<div className="bg"></div>
			              			<div className="row">
				            	 
				            		<div className="col-md-12 col-12">
				            			<div className="carousel-caption">
					              			<div className="row">
								                
								                <div className="col-sm-12 col-12">
								               
								                  <small className="ignite-ask-me-anything__intro"><em>“Thank you for the session!”</em></small>
                                  <h2 className="ignite-ask-me-anything__intro">- Shubhranka Mondal</h2>
								                </div>
					              			</div>
					            		</div>
				            		</div>
			            		</div>
			          		</div>
			    		</div>
				        <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
				          <span className="carousel-control-prev-icon" aria-hidden="true"> <img style={{width:"10px"}} src={"https://winpeforum.com/assets/elements/left.png"}/>

                  </span>
				          <span className="sr-only">Previous</span>
				        </a>
				        <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
				          <span className="carousel-control-next-icon" aria-hidden="true">  <img style={{width:"10px"}} src={"https://winpeforum.com/assets/elements/right.png"}/>  </span>
				          <span className="sr-only">Next</span>
				        </a>
			  		</div>
				</div> 
        </div> 
	 



      <br/><br/><br/>


<h2 className="ignite-ask-me-anything__heading"  style={{fontSize: '30px'}}>Panelists</h2>
        <hr className="ignite-ask-me-anything__hr"></hr>
        <p className="ignite-ask-me-anything__intro">Included representatives from Apax, Blackstone, Everstone, General Atlantic, IFC, KKR, Michael Page, Multiples, Warburg Pincus, Sequoia India.</p>
        <br />
        <br />
        <br />
        
        <br />
        <h4 className="ignite-ask-me-anything__heading" id="IndustryLeaders" style={{fontSize: '20px'}}>Win a 1:1 chat with Industry Leaders</h4>
       

        <hr className="ignite-ask-me-anything__hr"></hr>
        
        <div className="Our_Speakers container">
                   
                  <div className="Speakers_img">
                    <div className="row">
                      {this.Speaker.map((item, i) => {
                        return (
                          <div
                            className="main_speaker_card col-md-2 col-sm-4 col-lg-2"
                            key={i}
                          >
                            <div className="Scardd">
                              <div
                                className="s_img"
                                onClick={() => this.togglePopUp(item)}
                              >
                          <br/>  <center>  <img
                                  src={item.imgUrl}
                                  alt={item.name}
                                  className="img-responsive"
                                  style={{borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover'}}
                                />
</center>
                              </div>
                             <br/>    <div
                                className="Speakers_name"
                                dangerouslySetInnerHTML={{ __html: item.name }}
                              ></div>
                              <div
                                className="Speakers_post"
                                dangerouslySetInnerHTML={{ __html: item.post }}
                              ></div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
<br/>    
<br />
        <h4 className="ignite-ask-me-anything__heading" id="IndustryLeaders" style={{fontSize: '20px'}}>Session 1</h4>
        <p class="ignite-ask-me-anything__date">Panel discussion with recent hires on getting that investing job</p>
       

        <hr className="ignite-ask-me-anything__hr"></hr>
        
      <div className="Our_Speakers container">
      <center>
                  <div className="Speakers_img" style={{width: '65%'}}>
                    <div className="row">
                      {this.Speaker1.map((item, i) => {
                        return (
                          <div
                            className="main_speaker_card col-md-3 col-sm-3 col-lg-3"
                            key={i}
                          >
                            <div className="Scardd">
                              <div
                                className="s_img"
                                onClick={() => this.togglePopUp(item)}
                              >
                         <br/>      <center>  <img
                                  src={item.imgUrl}
                                  alt={item.name}
                                  className="img-responsive"
                                  style={{borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover'}}
                                />
</center>
                              </div>
                             <br/>    <div
                                className="Speakers_name"
                                dangerouslySetInnerHTML={{ __html: item.name }}
                              ></div>
                              <div
                                className="Speakers_post"
                                dangerouslySetInnerHTML={{ __html: item.post }}
                              ></div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div> </center>
                </div>

                <br/>    
<br />
        <h4 className="ignite-ask-me-anything__heading" id="IndustryLeaders" style={{fontSize: '20px'}}>Session 2</h4>
        <p class="ignite-ask-me-anything__date"> Recruiters' insights on how to make a good CV</p>
       

        <hr className="ignite-ask-me-anything__hr"></hr>
        
        <div className="Our_Speakers container">
        <center>
      <div className="Speakers_img" style={{width: '65%'}}>
        <div className="row">
          {this.Speaker2.map((item, i) => {
            return (
              <div
                className="main_speaker_card col-md-3 col-sm-3 col-lg-3"
                key={i}
              >
                <div className="Scardd">
                  <div
                    className="s_img"
                    onClick={() => this.togglePopUp(item)}
                  >
              <br/>     <center>  <img
                      src={item.imgUrl}
                      alt={item.name}
                      className="img-responsive"
                      style={{borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover'}}
                    />
</center>
                  </div>
                 <br/>    <div
                    className="Speakers_name"
                    dangerouslySetInnerHTML={{ __html: item.name }}
                  ></div>
                  <div
                    className="Speakers_post"
                    dangerouslySetInnerHTML={{ __html: item.post }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div> </center>
    </div>
    <br/>    
<br />
        <h4 className="ignite-ask-me-anything__heading" id="IndustryLeaders" style={{fontSize: '20px'}}>Session 3</h4>
        <p class="ignite-ask-me-anything__date">Mock interview panel</p>
       

        <hr className="ignite-ask-me-anything__hr"></hr>
        
        <div className="Our_Speakers container">
        <center>
      <div className="Speakers_img" style={{width: '45%'}}>
        <div className="row">
          {this.Speaker3.map((item, i) => {
            return (
              <div
                className="main_speaker_card col-md-6 col-sm-6 col-lg-6"
                key={i}
              >
                <div className="Scardd">
                  <div
                    className="s_img"
                    onClick={() => this.togglePopUp(item)}
                  >
              <br/> <center>  <img
                      src={item.imgUrl}
                      alt={item.name}
                      className="img-responsive"
                      style={{borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover'}}
                    />
</center>
                  </div>
                 <br/>    <div
                    className="Speakers_name"
                    dangerouslySetInnerHTML={{ __html: item.name }}
                  ></div>
                  <div
                    className="Speakers_post"
                    dangerouslySetInnerHTML={{ __html: item.post }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>
      </div> </center>
    </div><br/>    
<br />
                <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
      </div></div> 
      </ContentPage>
    );
  }
}
CareerBootcamp.propTypes = {
  location: PropTypes.object,
};

export default CareerBootcamp;



// WEBPACK FOOTER //
// ./src/pages/careerbootcamp/index.js